/**
 * Created by vinay on 18/12/18.
 */
import cloneDeep from 'clone-deep';
import {
    isArrayValidAndNotEmpty,
    sortArrayOfObjectsByFieldValue,
} from '../constants/CommonUtil';
import { formatDate, getDateInYYYYMMDDFormat } from '../constants/DateUtil';
import { getStringFromObject } from '../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../constants/nullCheckUtils';
import { divide, getScaledAndRoundedBigDecimal, round } from '../constants/PrecisionUtil';
import { NumberOf } from '../constants/numberUtils';
import { PRICE_FOR_QUANTITY_ROUNDING_DIGITS } from '../constants/constants';

export const ADD_STOCK_OPERATION = {
    SAVE: 'save',
    CONFIRM: 'confirm',
};

const mapStockPickingLinesFromUiObject = (lines) => {
    console.log('these are the lines', lines);
    const stockPickingLines = [];
    if (isArrayValidAndNotEmpty(lines)) {
        lines.forEach((line, index) => {
            if (line.product && line.product.uuid) {
                const stockPickingLine = {
                    product: {
                        key: getStringFromObject('product.uuid', line, null),
                        value: getStringFromObject('product.productName', line, ''),
                    },
                    batchName: getStringFromObject('description', line, null),
                    quantity: getStringFromObject('quantity', line, 0),
                    productUom: {
                        key: getStringFromObject('uom.uuid', line, null),
                        value: getStringFromObject('uom.name', line, ''),
                    },
                    cost: getStringFromObject('cost', line, 0),
                    userCost: getStringFromObject('totalCostPrice', line, null),
                    salePrice: getStringFromObject('salePrice', line, 0),
                    mrp: getStringFromObject('mrp', line, 0),
                    uuid: getStringFromObject('uuid', line, null),
                    expiryDate: formatDate(getStringFromObject('expiry', line, new Date()), 'yyyy-MM-dd hh:mm:ss'),
                    // To start sequence from 1
                    sequence: index + 1,
                    productGtinMapDto: getStringFromObject('productGtinMapDto', line) || null,
                };
                stockPickingLines.push(stockPickingLine);
            }
        });
    }
    console.log('these are the stock lines', stockPickingLines);
    return stockPickingLines;
};

export const mapAddStockFromUiObject = (uiObject, action) => {
    const payload = {};
    if (isObjectValidAndNotEmpty(uiObject)) {
        payload.uuid = uiObject.uuid;
        payload.status = action;
        payload.origin = uiObject.reference;
        payload.operation = 'ADD_STOCK';
        payload.destLoc = {
            key: getStringFromObject('location.uuid', uiObject, null),
            value: getStringFromObject('location.name', uiObject, ''),
        };
        payload.stockPickingLinesDTOSet = mapStockPickingLinesFromUiObject(uiObject.addStock);
        payload.date = getStringFromObject('date', uiObject) || new Date().getTime;
    }
    return payload;
};

const mapStockPickingLineUiObject = (lines) => {
    console.log('dhalkdjfhaklsdfhakls', lines);
    let stockPickingLines = [];
    if (isArrayValidAndNotEmpty(lines)) {
        stockPickingLines = lines.map((stock, index) => {
            const productUuid = getStringFromObject('product.key', stock, '');
            const uomUuid = getStringFromObject('productUom.key', stock, '');
            const uosUuid = getStringFromObject('productUos.key', stock, '');
            const quantity = getStringFromObject('quantity', stock, 0);
            const uosQuantity = getStringFromObject('uosQuantity', stock, null);
            const userCost = getStringFromObject('userCost', stock, 0);
            const unitCost = getStringFromObject('unitCost', stock, null);
            const productId = getStringFromObject('productId', stock, 0);
            const baseUom = getStringFromObject('productUom.extraField', stock, '');
            const uom = getStringFromObject('productUos.extraField', stock, '');

            const uomFactor = getStringFromObject('factor', uom, 1);
            const baseUomFactor = getStringFromObject('factor', baseUom, 1);
            const isSameUom =
                getStringFromObject('uuid', uom, null) &&
                getStringFromObject('uuid', baseUom, null) &&
                getStringFromObject('uuid', uom, null) === getStringFromObject('uuid', baseUom, null);
            const conversionFactor = isSameUom
                ? getScaledAndRoundedBigDecimal(1)
                : getScaledAndRoundedBigDecimal(NumberOf(uomFactor)).mul(1 / NumberOf(baseUomFactor || 1));

            // Check if UOM and UOS are different
            const isUomDifferentFromUos = uomUuid && uosUuid && uomUuid !== uosUuid;

            // Use uosQuantity when UOM and UOS are different, otherwise use quantity
            const displayQuantity = isUomDifferentFromUos && uosQuantity !== null
                ? NumberOf(uosQuantity)
                : NumberOf(quantity);

            // Use unitCost if available, otherwise calculate from userCost and quantity
            let fallbackCost = 0;
            if (displayQuantity > 0) {
                fallbackCost = NumberOf(divide(userCost, displayQuantity));
            }
            const costPerUom = unitCost !== null ? NumberOf(unitCost) : fallbackCost;

            // When UOM and UOS are different, use UOS for the uom field
            const displayUom = isUomDifferentFromUos ? uom : baseUom;

            // Try to get uomCategoryId from various possible locations in backend response
            // Priority: explicit uomCategoryId field > productUom category > productUos category
            const uomCategoryId = getStringFromObject('category', baseUom) ||
                                getStringFromObject('category.key', baseUom) || 0;

            // Build product object with erpUomDto structure for UOM search API
            // Use UOM (not UOS) for erpUomDto as it represents the product's base UOM
            const product = {
                uuid: productUuid,
                productName: getStringFromObject('product.value', stock, ''),
                erpUomDto: baseUom,
                productId: productId || 0,
            };

            const temp = {
                product,
                // When UOM and UOS are different, set uom field to UOS unit
                uom: displayUom,
                cost: getStringFromObject('productCost', stock, 0),
                weightedCost: getStringFromObject('weightedCost', stock, ''),
                // Use unitCost from backend if available, preserve as-is to maintain 5 decimal precision
                costPerUom,
                // Preserve totalCostPrice as returned from backend to maintain consistency and 5 decimal precision
                totalCostPrice: round(conversionFactor.mul(costPerUom).mul(uosQuantity), PRICE_FOR_QUANTITY_ROUNDING_DIGITS),
                salePrice: getStringFromObject('salePrice', stock, 0),
                mrp: getStringFromObject('mrp', stock, 0),
                // Use uosQuantity when UOM and UOS are different, otherwise use quantity
                quantity: displayQuantity,
                uuid: getStringFromObject('uuid', stock, null),
                trackByBatch: getStringFromObject('productTrackByBatch', stock, false),
                sequence: stock.sequence || index,
                productGtinMapDto: getStringFromObject('productGtinMapDto', stock) || null,
                // Preserve productId and uomCategoryId for UOM search API
                // uomCategoryId is critical for UOM search API, ensure it's preserved
                productId: productId || 0,
                uomCategoryId: NumberOf(uomCategoryId) || 0,
            };
            if (temp.trackByBatch) {
                temp.description = getStringFromObject('batchName', stock, '');
                temp.expiry = getDateInYYYYMMDDFormat(new Date(getStringFromObject('expiryDate', stock, new Date())));
            }
            return temp;
        });
    } else {
        stockPickingLines.push({});
    }
    console.log('productTrackByBatch', stockPickingLines);
    return sortArrayOfObjectsByFieldValue(stockPickingLines, 'sequence');
};

export const UI_OBJECT = {
    date: new Date().getTime(),
    addStock: [{ expiry: getDateInYYYYMMDDFormat(new Date()), uomCategoryId: 0, productId: 0 }],
};

export const mapAddStockDtoToUiObject = (stock) => {
    let uiObject = cloneDeep(UI_OBJECT);
    console.log('hgaksdgfkajsgf', stock);
    if (isObjectValidAndNotEmpty(stock)) {
        uiObject = {
            ...uiObject,
            createDate: getStringFromObject('createDate', stock),
            createdBy: getStringFromObject('receivedBy', stock),
            reference: getStringFromObject('origin', stock, ''),
            uuid: getStringFromObject('uuid', stock, ''),
            location: {
                uuid: getStringFromObject('destLoc.key', stock, ''),
                name: getStringFromObject('destLoc.value', stock, ''),
            },
            status: getStringFromObject('status', stock, ''),
            addStock: mapStockPickingLineUiObject(getStringFromObject('stockPickingLinesDTOSet', stock, [])),
            date: getStringFromObject('date', stock) || null,
        };
    }
    return uiObject;
};
